// extracted by mini-css-extract-plugin
export var actionIcon = "_tt-0";